export const INPUT_FILE_ACCEPT_DOC = 'image/*,.pdf,.doc,.docx,.xls,.xlsx';
